import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

import { fieldRoot } from '../form-field.styles';

export { fieldFocused as focused, fieldError as error } from '../form-field.styles';

// The box model here has to stay identical to `Input`'s: `PhoneNumberField`
// lays a NativeSelect and an Input side by side in a flex row, so any
// difference in padding or in where the bottom rule is painted shows up as
// two misaligned underlines. Kept in sync with input.styles.ts.
export const root = (theme: Theme) => css`
  /* needs to be relative to render chevron over <select></select> */
  position: relative;
  ${fieldRoot(theme)}

  option {
    color: ${theme.palette.text.title};
    background-color: ${theme.palette.background.main};
  }
`;

export const select = (theme: Theme) => css`
  cursor: pointer;
  appearance: none;
  border: none;
  width: 100%;
  padding: 0;
  /* 16px to prevent ios zooming */
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  color: ${theme.palette.text.title};
  caret-color: ${theme.palette.secondary.mainContrast};
  background-color: transparent;

  &::placeholder {
    color: ${theme.palette.text.emptyState};
    font-weight: 400;
  }

  &:disabled {
    opacity: 1; /* required on iOS */
    -webkit-text-fill-color: ${theme.palette.text.emptyState}; /* required on iOS */
    color: ${theme.palette.text.emptyState};
  }
`;

export const chevron = (theme: Theme) => css`
  color: ${theme.palette.icons.main};
  position: absolute;
  right: 0;
  /* allow opening select */
  pointer-events: none;
`;

export const startAdornment = (theme: Theme) => css`
  margin-right: ${theme.spacing[8]};
`;
